<template>
  <div class="cards">
    <!-- show only 2 card because of performance, not needed to render all available cards -->
    <GameCard
      v-if="cardsLeft > 0"
      :key="cardUnder.id"
      :card="cardUnder"
      :index="cardsLeft - 1"
      :is-current="false"
      @cardAccepted="$emit('cardAccepted', cardUnder.id)"
      @cardRejected="$emit('cardRejected', cardUnder.id)"
      @cardSkipped="$emit('cardSkipped')"
      @hideCard="$emit('hideCard')"
      @moreInfos="$emit('moreInfos')"
    />

    <GameCard
      :key="cardToShow.id"
      :card="cardToShow"
      :index="cardsLeft"
      :is-current="true"
      @cardAccepted="$emit('cardAccepted', cardToShow.id)"
      @cardRejected="$emit('cardRejected', cardToShow.id)"
      @cardSkipped="$emit('cardSkipped')"
      @hideCard="$emit('hideCard')"
      @moreInfos="$emit('moreInfos')"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import GameCard from '@/components/GameCard';

export default {
  name: 'cards-stack',

  props: {
    cards: {
      type: Array,
      required: true,
    },
  },

  components: {
    GameCard,
  },

  computed: {
    ...mapState(['visibleCards']),

    cardToShow() {
      return this.cards[this.cardsLeft];
    },

    cardUnder() {
      return this.cards[this.cardsLeft - 1];
    },

    cardsLeft() {
      return this.visibleCards.length - 1 > 0 ? this.visibleCards.length - 1 : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.cards {
  position: relative;
  display: flex;
  // margin: 50px;
  margin-bottom: 40px;
  width: 80vw;
  max-width: 500px;
}
</style>
